(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifelong-header"]) return;
  try {
    
  if (!customElements.get('lifelong-header')) {
    customElements.define('lifelong-header', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.menu = this.querySelector('details');
        this.toggleButton = this.menu.querySelector('summary');
        this.drawer = this.querySelector('[role="dialog"]');
        this.mobileSearch = this.drawer.querySelector('input[type="search"]');
        this.desktop = window.matchMedia('(min-width: 1000px)');
        this.headerSection = this.closest('.lifelong-header-section');
        this.lastScrollY = Math.max(0, window.scrollY);
        this.onScroll = () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = 0;
            const position = Math.max(0, window.scrollY);
            const keyboardFocus = this.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
            if (this.menu.open || keyboardFocus || position <= this.headerSection.offsetHeight) {
              this.headerSection.classList.remove('lf-header-is-hidden');
              this.lastScrollY = position;
              return;
            }
            if (Math.abs(position - this.lastScrollY) < 6) return;
            this.headerSection.classList.toggle('lf-header-is-hidden', position > this.lastScrollY);
            this.lastScrollY = position;
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true, signal: this.events.signal });
        this.addEventListener('focusin', () => this.headerSection.classList.remove('lf-header-is-hidden'), options);
        this.menu.addEventListener('toggle', () => this.syncMenu(), options);
        this.querySelector('[data-close-menu]').addEventListener('click', () => { this.menu.open = false; }, options);
        this.querySelector('[data-open-search]').addEventListener('click', (event) => {
          if (this.desktop.matches) return;
          event.preventDefault();
          this.focusSearch = true;
          this.menu.open = true;
          requestAnimationFrame(() => this.mobileSearch.focus());
        }, options);
        this.drawer.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => { this.menu.open = false; }, options));
        this.addEventListener('keydown', (event) => {
          if (!this.menu.open) return;
          if (event.key === 'Escape') { event.preventDefault(); this.menu.open = false; return; }
          if (event.key !== 'Tab') return;
          const controls = [this.toggleButton, ...this.drawer.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled])')].filter((node) => node.getClientRects().length);
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }, options);
        this.onBreakpoint = () => { if (this.desktop.matches) this.menu.open = false; };
        this.desktop.addEventListener('change', this.onBreakpoint);
      }
      syncMenu() {
        if (this.menu.open) {
          this.headerSection.classList.remove('lf-header-is-hidden');
          if (!this.locked) { this.previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; this.locked = true; }
          this.toggleButton.setAttribute('aria-expanded', 'true');
          if (this.focusSearch) this.mobileSearch.focus();
          else this.toggleButton.focus();
          this.focusSearch = false;
        } else {
          this.unlock();
          this.toggleButton.setAttribute('aria-expanded', 'false');
          if (!this.desktop.matches && this.isConnected) this.toggleButton.focus();
        }
      }
      unlock() {
        if (!this.locked) return;
        document.body.style.overflow = this.previousOverflow;
        this.locked = false;
      }
      disconnectedCallback() {
        this.unlock();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.headerSection?.classList.remove('lf-header-is-hidden');
        this.events?.abort();
        this.desktop?.removeEventListener('change', this.onBreakpoint);
        this.events = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifelong-workspace"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lifelong-rail')) {
    customElements.define('lifelong-rail', class extends HTMLElement {
      connectedCallback() {
        this.connectFrame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        if (this.controller) return;
        this.track = this.querySelector('[data-ll-track]');
        this.previous = this.querySelector('[data-ll-prev]');
        this.next = this.querySelector('[data-ll-next]');
        if (!this.track || !this.previous || !this.next) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.previous.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.track.addEventListener('scroll', () => this.scheduleUpdate(), { passive: true, signal });
        this.track.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey) return;
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') this.go(0);
          else if (event.key === 'End') this.go(this.track.scrollWidth);
          else this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }, { signal });
        this.observer = new ResizeObserver(() => this.scheduleUpdate());
        this.observer.observe(this.track);
        const media = this.track.querySelector('[data-ll-media]');
        if (media) this.observer.observe(media);
        this.classList.add('is-ready');
        this.update();
      }
      scheduleUpdate() {
        cancelAnimationFrame(this.updateFrame);
        this.updateFrame = requestAnimationFrame(() => this.update());
      }
      update() {
        const maximum = Math.max(0,this.track.scrollWidth - this.track.clientWidth);
        const left = Math.max(0,this.track.scrollLeft);
        this.previous.disabled = left <= 1;
        this.next.disabled = maximum <= 1 || left >= maximum - 1;
        const media = this.track.querySelector('[data-ll-media]');
        if (media) this.style.setProperty('--ll-nav-y',media.getBoundingClientRect().height / 2 + 'px');
      }
      move(direction) {
        const card = this.track.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
        this.go(this.track.scrollLeft + direction * step);
      }
      go(left) {
        const maximum = Math.max(0,this.track.scrollWidth - this.track.clientWidth);
        this.track.scrollTo({ left: Math.max(0,Math.min(maximum,left)), behavior: this.motion.matches ? 'auto' : 'smooth' });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.connectFrame);
        cancelAnimationFrame(this.updateFrame);
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
        this.classList.remove('is-ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
